import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

import { ServicesService } from './services.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ServicesComponent implements OnInit, OnDestroy {

	public data: object = {};
	private inscription: Subscription;
	constructor(private _service: ServicesService, private _titleService: Title, private _meta: Meta) {
		this._titleService.setTitle( 'Serviços - Hospital Veterinário Stolf');
		this.listAll();
	}

	ngOnInit() {
		this._meta.addTag({
			name: 'title',
			content: 'Serviços - Hospital Veterinário Stolf - Lages SC'
		});
		this._meta.addTag({
			name: 'description',
			content: 'O Hospital Veterinário Stolf oferece diversos serviços como: estética animal, acupuntura, cirurgias gerais e ortopédicas, dermatologia. Conheça mais sobre estes e muitos outros serviços			'
		});
	}

	listAll() {
		this.inscription = this._service.listAll()
		.subscribe(
			response => {
				this.data['itens'] = response;
			},
			error => {
				console.error ( error );
			}
		);
	}

	ngOnDestroy() {
		// this.inscription.unsubscribe();
	}

}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/services/services.component.ts